import styled from 'styled-components';

interface Ready { ready: boolean; }

export const Map = styled.div`
  width: 100%;
  height: 100%;
`;

export const Nonakass = styled.div<Ready>`
  position: absolute;
  top: 0;
  left: 0;
  width: 80px;
  height: 80px;
  margin-top: -80px;
  margin-left: calc(-80px / 2);
  opacity: ${p => p.ready ? 1 : 0};
`;

export const NagataStation = styled.div<Ready>`
  position: absolute;
  top: 0;
  left: 0;
  width: 40px;
  height: 40px;
  margin-top: -40px;
  margin-left: calc(-40px / 2);
  opacity: ${p => p.ready ? 1 : 0};
`;

export const TokuanStation = styled.div<Ready>`
  position: absolute;
  top: 0;
  left: 0;
  width: 40px;
  height: 40px;
  margin-top: -40px;
  margin-left: calc(-40px / 2);
  opacity: ${p => p.ready ? 1 : 0};
`;
